(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairCyberSessionsInfoController', VirtualFairCyberSessionsInfoController);
    VirtualFairCyberSessionsInfoController.$inject = ['VirtualFairService', 'isPlatformRental', 'virtualFairs'];
    function VirtualFairCyberSessionsInfoController(VirtualFairService, isPlatformRental, virtualFairs) {
        var vm = this;

        vm.getByFilter = getByFilter;
        vm.activate = activate;

        vm.virtualFairSelected = '';
        vm.flag = false;
        vm.isPlatformRental = isPlatformRental;
        

        function getByFilter() {
            vm.flag = false;
            let query = {};
            query['virtual_fair_id'] = vm.virtualFairSelected;
            if (vm.isPlatformRental) {
                query['platform-rental'] = 1;
            }
            VirtualFairService.getCyberSessionInformation(query).then(function (response) {
                vm.flag = true;
                vm.generalInformation = response.data;
            });

            vm.cyberSessionsData = [];
            VirtualFairService.getCyberSessionsByReport(query, true)
                .then(async function (response) {
                    var rawData = response.data;
                    vm.cyberSessionsData = await Object.keys(rawData).map(function (universityName) {
                        return {
                            name: universityName,
                            rooms: Object.keys(rawData[universityName]).map(function (roomName) {
                                console.log(rawData[universityName][roomName])
                                return {
                                    name: roomName,
                                    sessions: rawData[universityName][roomName],
                                };
                            })
                        };
                    });

                    console.log(vm.cyberSessionsData);
                    vm.to = response.data.to;
                    vm.totalItems = response.data.total;
                    vm.itemsPerPage = response.data.per_page;
                    vm.setPage(response.data.current_page);
                });
        }

        function activate() {
            vm.virtualFairs = virtualFairs ? virtualFairs : [];
        }

        vm.activate();
    }
})();